const fontFamily = "'Roboto Mono', monospace"

export const fonts = {
  light: {
    fontFamily,
    fontWeight: 300
  },
  medium: {
    fontFamily,
    fontWeight: 400,
  },
  heavy: {
    fontFamily,
    fontWeight: 700
  }
}



// WEBPACK FOOTER //
// ./src/docs/styles.js